import { channelClient, RequestPolicies } from 'shared/channels';
import { createEntityClient, runQueuedMutation } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { organizationContract, type OrganizationLogoAddress } from './organizationContract';
import type { OrganizationCreateModel, OrganizationEditModel, OrganizationModel } from './types/model';

/**
 * Organizations as served by the service worker. Changes resolve once the
 * server accepted them and reject with its error (`ChannelRequestError.messageId`).
 */
export const organizationClient = {
  ...createEntityClient(organizationContract),

  /** Resolves with the organization the server created. */
  create(organizationCreateModel: OrganizationCreateModel): Promise<OrganizationModel> {
    return runQueuedMutation(
      organizationContract,
      'create',
      (uniqueId) => ({ organizationCreateModel, uniqueId }),
      DomainMessagesTypes.createdEntity
    );
  },

  async edit(organizationEditModel: OrganizationEditModel): Promise<void> {
    await runQueuedMutation(
      organizationContract,
      'edit',
      (uniqueId) => ({ organizationEditModel, uniqueId }),
      DomainMessagesTypes.updatedEntity
    );
  },

  /** A signed URL to download the organization's logo. */
  getLogoSignedUrl(logo: OrganizationLogoAddress): Promise<string> {
    return channelClient.request(organizationContract, 'getLogoSignedUrl', logo, RequestPolicies.read);
  },
};
